import Page from '../../components/Page';
import React from 'react';

import Container from '../../components/Container/Container';

import styles from './FAQ.module.scss';
import Card from 'components/Card/Card';
import Divider from 'components/Divider/Divider';

const FAQ = () => {
    return (
        <Page title="Често Задавани Въпроси">
            <Container center className={styles.container}>
                <h2>Често Задавани Въпроси</h2>

                <div className={styles.faqContainer}>
                    <Card className={styles.card}>
                        <h3>Какъв е дрескодът?</h3>
                        <p>Бихме се радвали да се облечете официално. Най-важното е да се чувствате удобно и празнично!</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>Мога ли да дойда с половинката си?</h3>
                        <p>Разбира се, с радост ще посрещнем и вашата половинка. Моля да ни информирате предварително.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>Има ли опция за нощувки?</h3>
                        <p>Да, локацията предлага настаняване. Възможно е да се уредят преференциални цени за гости на сватбата.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>Какъв подарък да нося?</h3>
                        <p>Най-ценното е, че ще сте с нас. Ако все пак желаете, бихме оценили паричен подарък в пликче. Цветя не са необходими.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>Как да потвърдя присъствието си?</h3>
                        <p>Моля, потвърдете присъствието си до март месец чрез формата в сайта или ни кажете лично.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>В колко часа трябва да пристигна?</h3>
                        <p>Заповядайте на коктейл от 17:00 часа. Церемонията ще започне към 18:00.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>Церемонията и ресторантът на открито или закрито ще бъдат?</h3>
                        <p>Церемонията ще бъде на открито, ресторантът е на закрито, има излаз към тераса от залата.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card className={styles.card}>
                        <h3>Как мога да стигна до локацията?</h3>
                        <p>До локацията може да стигнете с кола или такси. Има голям паркинг на разположение на място.</p>
                    </Card>
                    <Divider className={styles.divider} />
                    <Card>
                        <h3>Как мога да се свържа с вас?</h3>
                        <p>По Messenger, Viber или по телефона.<br/><strong>Ками:</strong> 0878718904<br/><strong>Христо:</strong> 0899606977</p>
                    </Card>
                </div>
            </Container>
        </Page>
    );
};

export default FAQ;